import React from 'react';
import {FormikSwitcher, getToken, Helper, Label} from '@tickchak/react-share/app';
import * as css from './ToggleSection.css';

interface ToggleSectionProps {
    fieldName: string;
    title: string;
    description: string;
    activeLabel: string;
    inActiveLabel: string;
    statusLabel?: string;
    showHelpIcon?: boolean;
    onHelpClick?: () => void;
}

function ToggleSection({
    fieldName,
    title,
    description,
    activeLabel,
    inActiveLabel,
    statusLabel,
    showHelpIcon = false,
    onHelpClick
}: ToggleSectionProps) {
    return (
        <css.container>
            <css.contentColumn>
                <css.titleRow>
                    <css.title>{title}</css.title>
                    {statusLabel && (
                        <Label 
                            color={getToken('color.state.info.main')} 
                            backgroundColor={getToken('color.state.info.bg')}
                        >
                            {statusLabel}
                        </Label>
                    )}
                </css.titleRow>
                <css.description>{description}</css.description>
            </css.contentColumn>
            <css.controlsWrapper>
                <FormikSwitcher
                    name={fieldName}
                    label={{
                        on: activeLabel,
                        off: inActiveLabel,
                        show: true
                    }}
                />
                {showHelpIcon && onHelpClick && (
                    <css.helpIconWrapper onClick={onHelpClick}>
                        <Helper size="small" />
                    </css.helpIconWrapper>
                )}
            </css.controlsWrapper>
        </css.container>
    );
}

export default ToggleSection;